import { BaseScreen, StagePlugin } from '@goodboydigital/astro';
import { Container } from 'pixi.js';

import { App, Shared } from '../App';
import { Game } from '../game/Game';

export class GameScreen extends BaseScreen
{
    public app: App;
    public options: {game: typeof Game};
    public manifests: string[] = [];
    public view: Container;
    public gameView: Container;
    public stage: Container;
    public game!: Game;

    constructor(app: App, options: {game: typeof Game})
    {
        super(app);
        this.app = app;
        this.view = new Container();
        this.gameView = new Container();
        this.stage = new Container();
        this.options = options;
    }

    public async init(): Promise<void>
    {
        this.game = new this.options.game({
            stage: this.stage,
            renderer: this.app.get(StagePlugin).renderer,
            app: this.app,
            screen: this,
        });
        this.gameView.addChild(this.stage);
        this.view.addChild(this.gameView);

        this.game.init();
        
        Shared.game = this.game;
    }

    public async show(): Promise<void>
    {
        this.resize(this.width, this.height);
        this.game.idle();
    }

    public resize(w: number, h: number): void
    {
        super.resize(w, h);
        this.view.x = (this.width - this.app.width) * 0.5;
        this.gameView.x = -((this.width - this.app.width) * 0.5);
        this.game && this.game.resize(w, h);
    }
}
